var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"HeaderTopLogin"},[_c('LoginForm',{attrs:{"redirect-path":_vm.$route.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }